// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"e6da7c13","294":"8738afa7","298":"c81e8656","449":"d3773606","463":"c6e10f93","473":"ab8f31e6","861":"5c99ab36","889":"08c7eb59","956":"8b94de15"}[chunkId] + ".chunk.js";
};